import editBudgetStore from "../../../../helpers/Budget/editBudgetStore";

const addBudgetGroupResponder = (queryClient) => {
  return {
    onSuccess: (returnedData) => {
      const { groups } = returnedData;
      const metadata = returnedData?.metadata;
      const id = returnedData?.id;

      editBudgetStore({
        queryClient,
        id,
        updatedFields: { groups, metadata },
      });
    },
    onError: (err) => console.error("Error", err),
  };
};

export default addBudgetGroupResponder;
